import type { ReactNode } from "react";

export function Spinner({ label }: { label?: string }) {
  return (
    <span role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      {label ? <span style={{ marginLeft: 8 }}>{label}</span> : null}
    </span>
  );
}

export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="state" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <div>{label}</div>
    </div>
  );
}

export function EmptyState({ title, children }: { title?: string; children?: ReactNode }) {
  return (
    <div className="state">
      {title ? <p className="state-title">{title}</p> : null}
      {children}
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: string; onRetry?: () => void }) {
  return (
    <div className="state" role="alert">
      <p style={{ color: "var(--danger)" }}>{error}</p>
      {onRetry ? (
        <button className="btn small" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  );
}

export function Alert({
  kind,
  children,
}: {
  kind: "error" | "success" | "info";
  children: ReactNode;
}) {
  return (
    <div className={`alert ${kind}`} role={kind === "error" ? "alert" : "status"}>
      {children}
    </div>
  );
}
